import CustomScroll from '@src/component/customScroll';
import { getOrderApproval } from '@src/service/ownService';
import { Toast } from 'antd-mobile';
import { memo, useEffect, useState } from 'react';
import { getPhoneNumber } from '@src/service/commonService';
import '../index.scss';

const Schedule = (props: any) => {
  const { loanid } = props;
  const [phone, setPhone] = useState<string>();
  const [data, setData] = useState<any[]>([]);
  useEffect(() => {
    getPhoneNumber()
      .then((res) => {
        setPhone(res.value);
      })
      .catch((err) => {
        Toast.show(err?.errmsg || '电话查询失败');
      });
  });
  useEffect(() => {
    loanid && getData();
  }, [loanid]);

  const getData = async () => {
    try {
      const list = await getOrderApproval(loanid);
      setData(list.data);
    } catch (err: any) {
      Toast.show(err?.errmsg || '数据请求失败');
    }
  };

  return (
    <div className="page bottomFit Schedule">
      <CustomScroll>
        <div className="yw">
          若有疑问，请联系EMOTOR客服中心电话：
          <span
            onClick={() => {
              location.href = `tel:${phone}`;
            }}
          >
            {phone}
          </span>
          <br />
          （工作日9:00-18:00）
        </div>
        <ul>
          {data.length > 0 &&
            data.map((_ele, _index) => (
              <li key={_index}>
                <div className="Schedule-content">
                  <i />
                  <p>{_ele?.opdesc}</p>
                  <span>{_ele?.optime}</span>
                </div>
                {_ele?.mark && _ele?.mark != '已使用信用卡分期业务' && (
                  <div className="Schedule-mark">{_ele?.mark}</div>
                )}
              </li>
            ))}
        </ul>
      </CustomScroll>
    </div>
  );
};

export default memo(Schedule);
